// /* eslint-disable */
import moment from 'moment';
import axios from 'axios';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import {
  INITIALIZE_SUCCESS, INITIALIZE_FAILURE, INITIALIZE_REQUEST,
  FETCH_RECORDS_REQUEST, FETCH_RECORDS_FAILURE, FETCH_RECORDS_SUCCESS,
  SET_PERIOD, SET_CANCEL_TOKEN,
} from './constants';
import { getEntries, getXapValue } from './api';
import { custom } from '../../utils/Api';
import pallet from '../../constants/colors';
import { isRedDay } from '../time/components/holidays';

const getDates = (startDate, endDate, lang) => {
  const dateArray = [];
  const currentDate = new Date(startDate);
  moment.locale(lang);
  while (currentDate <= endDate) {
    dateArray.push({
      dateString: moment(currentDate).format('DD/MM/YY'),
      date: moment(currentDate),
      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
      dayOfWeek: moment(currentDate).format('ddd'),
      isRedDay: isRedDay(currentDate),
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
};

const setCancelToken = cancelToken => ({
  type: SET_CANCEL_TOKEN,
  cancelToken,
});

export const setPeriod = (start, end, lang) => ({
  type: SET_PERIOD,
  start,
  end,
  datesBetween: getDates(start, end, lang),
});

export const fetchEntriesRequest = () => ({
  type: FETCH_RECORDS_REQUEST,
});

export const fetchEntriesSuccess = employees => ({
  type: FETCH_RECORDS_SUCCESS,
  employees,
});

export const fetchEntriesFailure = error => ({
  type: FETCH_RECORDS_FAILURE,
  error,
});

const getColor = (status) => {
  switch (status) {
    case 'Expired':
      return '#808080';
    case 'Accepted':
      return '#77BB97';
    case 'Pending':
      return pallet.warningColor;
    default:
      return pallet.errorColor;
  }
};

export const requestEntries = (start, end) => async (dispatch, getState) => {
  const {
    vacationApprovalsReducer: { cancelToken },
    loginReducer: { user: { EmployeeMasterID } },
  } = getState();
  if (cancelToken) {
    cancelToken.cancel();
  }
  try {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    dispatch(setCancelToken(source));
    dispatch(fetchEntriesRequest());

    const employeesRes = await custom(getEntries(start, end, EmployeeMasterID, source.token));
    const employeesData = get(employeesRes, 'data.value', []);

    const employees = [];
    employeesData.forEach((item) => {
      const { ApprovalRequests } = item;
      const approvalRequests = {};
      ApprovalRequests.forEach((request) => {
        const { PeriodBegda, PeriodEndda } = request;
        const from = moment(PeriodBegda);
        const to = moment(PeriodEndda);
        while (from <= to) {
          const existing = approvalRequests[from.format('DD/MM/YY')];
          // we don't need to show overlapping requests if existing request is accepted
          if (!existing || existing.status !== 'Accepted') {
            approvalRequests[from.format('DD/MM/YY')] = {
              duration: request.Duration,
              status: request.ApprovalRequestStatus,
              color: getColor(request.ApprovalRequestStatus),
              id: request.EmployeeDetailApprovalRequestID,
            };
          }
          from.add(1, 'days');
        }
      });
      employees.push({ ...item, approvalRequests });
    });
    dispatch(setCancelToken(null));
    dispatch(fetchEntriesSuccess(employees));
  } catch (error) {
    if (!axios.isCancel(error)) {
      dispatch(fetchEntriesFailure(error));
    }
  }
};

export const changePeriod = (start, end) => async (dispatch, getState) => {
  const {
    languageReducer: { language },
  } = getState();
  dispatch(setPeriod(start.startOf('day'), end.endOf('day'), language));
  dispatch(requestEntries(start.startOf('day'), end.endOf('day')));
};

export const initializeRequest = () => ({
  type: INITIALIZE_REQUEST,
});

export const initializeSuccess = (periodFrom, approvalStatusTypes) => ({
  type: INITIALIZE_SUCCESS,
  periodFrom,
  approvalStatusTypes,
});

export const initializeFailure = error => ({
  type: INITIALIZE_FAILURE,
  error,
});

export const initialize = () => async (dispatch) => {
  try {
    dispatch(initializeRequest());
    const requests = [
      custom(getXapValue('Pay.PeriodFrom')),
    ];
    const [xapRes] = await Promise.all(requests);
    let periodFrom = get(xapRes, 'data.value[0].Value');
    if (!periodFrom) {
      periodFrom = '1';
    }
    let startDate = moment().date(periodFrom).add(-1, 'months').startOf('day');
    let endDate = moment().date(periodFrom - 1).endOf('day');
    if (endDate.isSameOrBefore(moment())) {
      startDate = startDate.add(1, 'months');
      endDate = endDate.add(1, 'months');
    }

    const approvalStatusTypes = [
      {
        id: 'Accepted',
        value: 'Accepted',
        color: getColor('Accepted'),
      },
      {
        id: 'Pending',
        value: 'Pending',
        color: getColor('Pending'),
      },
      {
        id: 'Rejected',
        value: 'Rejected',
        color: getColor('Rejected'),
      },
      /* {
        id: 'Expired',
        value: 'Expired',
        color: getColor('Expired'),
      }, */
    ];

    dispatch(initializeSuccess(periodFrom, approvalStatusTypes));
    dispatch(changePeriod(startDate, endDate));
  } catch (error) {
    dispatch(initializeFailure(get(error, 'message')));
  }
};

export const useVacationApprovalsState = () => useSelector(state => state.vacationApprovalsReducer);



// WEBPACK FOOTER //
// ./src/sites/vacationApprovals/actions.js